export const DEFAULT_LOCALE = "en-US";

export const SUPPORTED_LOCALES = ["en-US", "zh-CN", "zh-TW", "ja-JP", "ko-KR"];

export const messages = {
  "en-US": {
    app: {
      totalStickersMade: "Total Stickers you made: {count}",
      notAvailable: "Not available",
      rotate: "Rotate",
      fontSize: "Font size",
      spacing: "Spacing",
      transparentBackground: "Transparent BG",
      curveBeta: "Curve (Beta)",
      text: "Text",
      copy: "Copy",
      download: "Download",
      about: "About",
      copiedImage: "Copied image to clipboard.",
    },
    picker: {
      pickCharacter: "Pick character",
      searchCharacter: "Search character",
    },
    info: {
      title: "About",
      credits: "This tool made possible by:",
      contributorRosemoe: "for the Arcaea variant of sticker maker",
      contributorXestarrrr: "for the Arcaea sticker images",
      contributorAyaka: "for the original sticker maker",
      sourceCode: "You can find the source code or contribute here:",
      sourceCodeLabel: "Source Code",
      totalStickersMade: "Total stickers made using the app:",
      totalStickersValue: "{count} stickers",
      close: "Close",
    },
  },
  "zh-CN": {
    app: {
      totalStickersMade: "你制作的贴纸总数：{count}",
      notAvailable: "不可用",
      rotate: "旋转",
      fontSize: "字号",
      spacing: "行距",
      transparentBackground: "透明背景",
      curveBeta: "曲线排列（Beta）",
      text: "文本",
      copy: "复制",
      download: "下载",
      about: "关于",
      copiedImage: "图片已复制到剪贴板。",
    },
    picker: {
      pickCharacter: "选择角色",
      searchCharacter: "搜索角色",
    },
    info: {
      title: "关于",
      credits: "本工具得以完成，感谢：",
      contributorRosemoe: "制作 Arcaea 版本贴纸生成器",
      contributorXestarrrr: "提供 Arcaea 贴纸图片",
      contributorAyaka: "制作原版贴纸生成器",
      sourceCode: "你可以在这里查看源码或参与贡献：",
      sourceCodeLabel: "源代码",
      totalStickersMade: "通过本应用生成的贴纸总数：",
      totalStickersValue: "{count} 张贴纸",
      close: "关闭",
    },
  },
  "zh-TW": {
    app: {
      totalStickersMade: "你製作的貼圖總數：{count}",
      notAvailable: "無法取得",
      rotate: "旋轉",
      fontSize: "字體大小",
      spacing: "行距",
      transparentBackground: "透明背景",
      curveBeta: "曲線排列（Beta）",
      text: "文字",
      copy: "複製",
      download: "下載",
      about: "關於",
      copiedImage: "圖片已複製到剪貼簿。",
    },
    picker: {
      pickCharacter: "選擇角色",
      searchCharacter: "搜尋角色",
    },
    info: {
      title: "關於",
      credits: "本工具得以完成，感謝：",
      contributorRosemoe: "製作 Arcaea 版本貼圖產生器",
      contributorXestarrrr: "提供 Arcaea 貼圖圖片",
      contributorAyaka: "製作原版貼圖產生器",
      sourceCode: "你可以在這裡查看原始碼或參與貢獻：",
      sourceCodeLabel: "原始碼",
      totalStickersMade: "透過本應用產生的貼圖總數：",
      totalStickersValue: "{count} 張貼圖",
      close: "關閉",
    },
  },
  "ja-JP": {
    app: {
      totalStickersMade: "作成したステッカー数: {count}",
      notAvailable: "利用できません",
      rotate: "回転",
      fontSize: "文字サイズ",
      spacing: "行間",
      transparentBackground: "背景を透明にする",
      curveBeta: "曲線配置（Beta）",
      text: "テキスト",
      copy: "コピー",
      download: "ダウンロード",
      about: "このアプリについて",
      copiedImage: "画像をクリップボードにコピーしました。",
    },
    picker: {
      pickCharacter: "キャラクターを選択",
      searchCharacter: "キャラクターを検索",
    },
    info: {
      title: "このアプリについて",
      credits: "このツールの制作に協力してくれた方々:",
      contributorRosemoe: "Arcaea 版ステッカーメーカーの制作",
      contributorXestarrrr: "Arcaea ステッカー画像の提供",
      contributorAyaka: "元のステッカーメーカーの制作",
      sourceCode: "ソースコードの確認や貢献はこちらから:",
      sourceCodeLabel: "ソースコード",
      totalStickersMade: "アプリで作成されたステッカー総数:",
      totalStickersValue: "{count} 枚",
      close: "閉じる",
    },
  },
  "ko-KR": {
    app: {
      totalStickersMade: "지금까지 만든 스티커 수: {count}",
      notAvailable: "사용할 수 없음",
      rotate: "회전",
      fontSize: "글자 크기",
      spacing: "줄 간격",
      transparentBackground: "투명 배경",
      curveBeta: "곡선 배치 (Beta)",
      text: "텍스트",
      copy: "복사",
      download: "다운로드",
      about: "정보",
      copiedImage: "이미지를 클립보드에 복사했습니다.",
    },
    picker: {
      pickCharacter: "캐릭터 선택",
      searchCharacter: "캐릭터 검색",
    },
    info: {
      title: "정보",
      credits: "이 도구 제작에 도움을 준 분들:",
      contributorRosemoe: "Arcaea 버전 스티커 메이커 제작",
      contributorXestarrrr: "Arcaea 스티커 이미지 제공",
      contributorAyaka: "원본 스티커 메이커 제작",
      sourceCode: "소스 코드 확인 및 기여:",
      sourceCodeLabel: "소스 코드",
      totalStickersMade: "앱으로 생성된 전체 스티커 수:",
      totalStickersValue: "{count}개",
      close: "닫기",
    },
  },
};
